import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C09300",
      d: "m19.512 19.333.11-.053-.252-5.702c-.018-.432-.222-.658-.56-.682-.263-.019-.596.087-.937.272-.538.328-1.166.357-1.889.116-.764.241-1.393.212-1.928-.114-.343-.187-.676-.293-.939-.274-.339.024-.542.25-.56.682l-.253 5.702.11.053 2.098-1.812h1.04l-.25 1.408.163.156.17-.12.213-1.444h.04l-.088 1.444.163.198.164-.198-.09-1.444h.042l.212 1.444.17.12.164-.156-.25-1.408h1.088z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M13.127 13.03c.231-.017.543.08.863.255.569.347 1.238.378 1.995.125.714.253 1.383.222 1.955-.127.317-.172.628-.27.86-.254.26.019.41.177.435.518-.12-.075-.286-.165-.356-.165l-1.663 1.085h-2.521l-1.663-1.085c-.067 0-.22.082-.34.154.027-.333.178-.489.434-.507",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C09300",
      d: "m14.783 15.8.113-.026.968 1.087-.58 2.515-.074.051-1.362-.198-.054-.085zm2.36 0 .989 3.344-.054.085-1.362.198-.074-.05-.564-2.576.952-1.027z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m13.943 19.108 1.226.178.581-2.394-.872-.942zm2.249-2.277.566 2.455 1.225-.178-.935-3.16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C09300",
      d: "M18.746 19.446c.079.006.138.054.213.145l.02.025c.052.062.076.078.107.07l.016.131c-.024 0-.03.007-.046.072-.008.032-.012.05-.019.07a.3.3 0 0 1-.159.192c-.007.21-.07.298-.294.337-.566.152-1.536.236-2.621.236-1.086 0-2.056-.084-2.607-.235-.237-.04-.3-.127-.308-.338a.3.3 0 0 1-.16-.193l-.018-.069c-.017-.065-.022-.072-.046-.072l.016-.131c.03.008.055-.008.106-.07l.02-.024c.075-.092.135-.14.214-.146a.3.3 0 0 1 .197-.236.19.19 0 0 1 .017-.2.27.27 0 0 1 .275-.11c.278.086.599.158.897.196.43.055.736.073.988.042.146 0 .252.138.225.262l.184.008h.186c-.03-.126.078-.27.239-.27.237.03.542.013.972-.042.299-.038.62-.11.902-.197.1-.021.212.027.27.11.044.065.05.137.017.201.106.04.177.12.197.236"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m18.878 19.701-.021-.025c-.068-.083-.102-.105-.158-.094l-.08-.065c0-.124-.07-.188-.203-.201l-.03-.122c.056-.037.063-.071.037-.108-.029-.041-.087-.066-.126-.058a6 6 0 0 1-.92.2c-.44.057-.754.075-.997.044-.09 0-.136.1-.066.144l-.035.123-.319.002-.3-.012-.037-.12c.057-.043.01-.137-.06-.138-.258.032-.573.014-1.014-.042a6 6 0 0 1-.913-.2c-.045-.01-.103.016-.132.057-.026.037-.019.071.037.108l-.03.122c-.133.013-.204.077-.204.201l-.08.065c-.055-.011-.09.011-.157.094l-.021.026a.5.5 0 0 1-.075.077q.015.032.025.077l.017.061c.021.067.052.103.118.124l.047.064c0 .187.02.223.204.254.543.148 1.503.232 2.578.232s2.035-.084 2.592-.233c.17-.03.19-.066.19-.253l.047-.064c.067-.02.097-.057.119-.124l.016-.06.026-.078a.5.5 0 0 1-.075-.078",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M15.962 17.37c1.693-1.24 1.547-3.057 1.547-3.057a1 1 0 0 1-.131.013c-.355 0-1.202-.193-1.4-.439-.211.222-1.077.44-1.43.44a1 1 0 0 1-.131-.014s-.148 1.816 1.545 3.056"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C09300",
      d: "M15.412 14.298c-.304.09-.634.15-.816.15l-.044-.005q.001.106.008.205.026.365.128.718c.143.495.39.94.724 1.322zm1.069-.005v2.432a3.46 3.46 0 0 0 .893-2.279l-.043.002a3.3 3.3 0 0 1-.85-.155m.193-.623c.01.057-.002.109-.076.105-.121-.01-.343-.07-.433-.175-.023.021-.152.249-.165.265l-.254-.264c-.089.145-.486.264-.486.264l.067-.247a3 3 0 0 1-.229.088 3 3 0 0 1-.378.04s.54-.559.667-.978c.121-.381.136-.73.057-.839-.114-.157-.22-.203-.333-.118-.06.046-.122.012-.14-.052a.3.3 0 0 1-.007-.123c.012-.11.052-.21.118-.251.106-.068.302-.066.546-.013.027-.051.082-.079.16-.075.252.013.587.11.699.216.13.124.2.399.181.862-.023.495.175 1.132.35 1.206l.24.165c-.11.029-.584-.08-.584-.076"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16.459 11.703c.058.126.09.342.076.666-.02.422.103.929.273 1.184-.011-.002-.29-.138-.314-.12-.012.007.016.164.026.189l.003.006a.7.7 0 0 1-.19-.075c-.058-.034-.16-.15-.176-.151-.015 0-.201.216-.203.218l-.21-.243s-.276.253-.284.257l.054-.257s-.258.154-.417.19q.084-.11.177-.26c.107-.17.19-.34.24-.498.109-.342.14-.661.086-.85.046-.02.17.007.17.007-.195-.318-.417-.393-.514-.387a.17.17 0 0 0-.123.07l-.037.015v-.014c.009-.072.035-.139.057-.153.027-.017.143-.018.282-.013a.6.6 0 0 1 .12.077c.116.087.207.13.264.12.018-.002.028.03.047.05.014.016.01.03.065.03.034 0 .053-.064.075-.082.029-.021.081-.03.116-.039.073-.017.108-.015.163-.02l.052-.002a.3.3 0 0 1 .122.085",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagEgy = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagEgy_default = SvgFlagEgy;

export { FlagEgy_default as default };
